// extracted by mini-css-extract-plugin
export default {"screen":"screen__b607e3e5","all-center":"all-center__e150b5b9","title":"title__708bbab5"};